module.exports = "/_next/static/images/77d80364d7f4fa88e7d7c1a27fbd8e00-tcv.png";